import { ChannelRole as BaseChannelRole } from '@pflegia/types/common/slack/channel-role';
import { TeamMessageThread as BaseTeamMessageThread } from '@pflegia/types/common/slack/team-message-thread';

export enum SlackChannel {
  AdminPanelErrors = 'admin_panel_errors',
  Boosters = 'booster_packages',
  CanceledInterviews = 'abgesagte-interviews',
  CandidateDeleted = 'candidate_deleted',
  CandidateRequestCall = 'candidate_requestscall_employer',
  CandidateUnpaused = 'candidate_unpaused',
  CareerCoachCallRequest = 'obc_call_request',
  CemPions = 'cem_pions',
  CemPlusRequest = 'cemplus_requests',
  ChaosComputerClub = 'chaoscomputerclub',
  ConductedInterviews = 'stattgefundene-interviews',
  ConfirmedInterviews = 'bestätigte-interviews',
  ContactUs = 'contact_us_requests',
  CvDone = 'cv_fertig',
  DociaRegistrations = 'docia-registrations',
  EmployerLandingPageRegistered = 'employer_registration',
  EmployerNoMatchData = 'employers_no_match_data',
  EmployerWithNoPushInvites = 'employers_with_no_push_invites',
  FailedEmails = 'fehlgeschlagene_emails',
  InterviewDates = 'newmatch_w_interviewrequest',
  InvalidRegistrations = 'invalid_registrations',
  ItAlerts = 'it_alerts',
  JobApplication = 'job_applications',
  KeyAccountMacintosh = 'key-account-macintosh',
  MagicLinkOfflineMatches = 'magic_link_offline_matches',
  MagicLinkOfflineMatchesStatistics = 'magic_link_offline_matches_statistics',
  Matches = 'matches',
  NewConductedInterviewsCem = 'cem-new-vts',
  NewConductedInterviewsKam = 'kam-new-vts',
  NewConfirmedInterviewsCem = 'cem-new-vtv',
  NewConfirmedInterviewsKam = 'kam-new-vtv',
  NewPhoneNumber = 'new_phone_number',
  NewPhoneNumberByEmployee = 'new_phone_number_pflegia_employees',
  Newsletter = 'pflegia_newsletter',
  OfflineMatches = 'offline_matches',
  OfflineMatchesStatistics = 'offline_matches_statistics',
  OmCheckAutomaticMatches = 'om_check_auto_matches',
  OnlineMatchesSummary = 'online_matches_summary',
  PriorityMatches = 'prio_matches',
  PriorityNewPhoneNumber = 'prio_new_phone_number',
  Registrations = 'registrations',
  RescheduledInterviewDates = 'rescheduled_interviewrequest',
  Statistics = 'statistics',
  TransferredMatches = 'transferred_matches',
  UserProfileUpdated = 'user_profile_update',
  UserUpgrade = 'user_upgrade',
}

export enum SlackChannelId {
  Registrations = 'C03UUNKDKFT',
  InvalidRegistrations = `C05DXN4K1SM`,
  TestRegistrations = 'C02HLPTQVPU',
  TestInvalidRegistrations = 'C05E3L765C5',
  DociaRegistrations = 'C0BHP3BUXAR',
  TestDociaRegistrations = 'C0BEYCGFWUT',
}

export enum SlackGroupId {
  CemCandidate = 'S04BTFP064A',
}

export type TeamMessageThread = BaseTeamMessageThread<SlackChannel>;
export type ChannelRole = BaseChannelRole<SlackChannel>;
